<div class="row">
  <div class="col-12">
    <hr>
  </div>
  <div class="col-12">
    <h3>{{ 'Add a new child' | translate }}</h3>
    <p></p>
  </div>
</div>
<app-partner-form [partner]='child' [isChild]="true" (eventFormValid)="onChildFormValid()" (eventFormInvalid)="onChildFormInvalid()"></app-partner-form>
<div class="row">
  <div class="col-12">
    <app-waiver-checkbox [(partner)]="parent"></app-waiver-checkbox>
  </div>
  <div class="col-12 col-md-6">
    <app-button [title]="'Cancel' | translate" [isLeftStyle]="true" (click)="cancelClick()"></app-button>
  </div>
  <div class="col-12 col-md-6">
    <app-button [title]="'Save' | translate" (clickEvent)="saveClick()" [disabled]="!isSaveButtonEnabled"></app-button>
  </div>
  <div class="col-12">
    <hr>
  </div>
</div>
